export const idDocuments = {
    DNI: {label: 'DNI', value: 'DNI'},
    PASS: {label: 'Pasaporte', value: 'PAS'},
}